import React from "react";
import { Box, Typography } from "@mui/material";

function Footer() {
  return (
    <Box
      sx={{
        bgcolor: "primary.main",
        p: 2,
        mt: "auto",
        textAlign: "center",
        position: "static",
        bottom: 0,
        width: "100%",
      }}
    >
      <Typography variant="body1" color="white" sx={{ fontSize: {xs: '12px'} }}>
        Copyright©freeks Inc. All Rights Reserved.
      </Typography>
    </Box>
  );
}

export default Footer;
